<template>
  <a-modal
    :title="$t('investorList.xgtzzt')"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('investorList.zt')">
        <a-select
          v-decorator="['status', { rules: [{ required: true, message: $t('pleaseSelect') }] }]"
          style="width: 200px"
        >
          <a-select-option v-for="item in assetStatusOptions" :key="item.itemValue" :value="item.itemValue">
            {{ getLangText(item) }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { getOrderStatus } from '@/webpublicapi/vietnamBackstage'
import { getDictList } from '@/webpublicapi/dict'

export default {
  name: 'AssetPackageStatusModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      record: null,
      form: this.$form.createForm(this),
      assetStatusOptions: [], // Asset package status options
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.record = record
      this.loadAssetStatusOptions()
      this.$nextTick(() => {
        this.form.setFieldsValue({
          status: String(record.investStatus),
        })
      })
    },
    // Load asset package status options
    loadAssetStatusOptions() {
      getDictList()
        .then((res) => {
          if (res.code === 1000 && res.data) {
            // getDictList Will automatically return all dictionary data, use directly investorderstatus
            this.assetStatusOptions = res.data.investorderstatus || []
          }
        })
        .catch((err) => {
          console.error('Get Investment Order Status Dictionary Failed:', err)
        })
    },
    // Get corresponding text based on current language
    getLangText(item) {
      const lang = this.$i18n.locale
      if (lang === 'en-US') {
        return item.itemTextEn 
      } else if (lang === 'es') {
        // Vietnamese stored in project in es.js
        return item.itemTextEs 
      } else {
        // Default return itemText
        return item.itemText
      }
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const params = {
            orderId: this.record.orderId,
            status: values.status,
          }

          getOrderStatus(params)
            .then((res) => {
              if (res.success || res.respCode === 1000) {
                this.$message.success(this.$t('success'))
                this.visible = false
                this.$emit('success')
              } else {
                this.$message.error(res.msg || this.$t('failed'))
              }
            })
            .catch((e) => {
              this.$message.error(e.message || this.$t('failed'))
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
